import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgxsModule } from "@ngxs/store";
import { AlertModule } from "@vp/shared/components/alert";
import { SystemBannerState } from "../state/system-banner-state";
import { SystemBannerComponent } from "./system-banner.component";

@NgModule({
  imports: [CommonModule, AlertModule, NgxsModule.forFeature([SystemBannerState])],
  declarations: [SystemBannerComponent],
  exports: [SystemBannerComponent]
})
export class SystemBannerModule {}
